var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext } from "react";
import FilteredOverviewPage from "../../components/FilteredOverviewPage";
import styles from "./CohortInsightsSkillV2.module.scss";
import { FilterContext } from "../../providers/FilterProvider";
import { CohortFilterSet } from "../../components/Filters/Filters";
import { useParams } from "react-router-dom";
import CohortInsightsSkillsTable from "../../components/CohortInsightsSkillsTable";
import PageNotFound from "../../components/PageNotFound";
import { DistributionBarSet } from "../../components/DistributionBarSet/DistributionBarSet";
import { Tab } from "../../common/cohortHelpers";
import { useGetCohortReportLeaderCount, useGetSingleAvailableCohortReportsQuery, } from "../../store/api/core";
import LeaderCount from "../../components/LeaderCount";
import { cohortSet } from "../../common/cohortConfiguration";
import { MutateReportButtons } from "../../components/Cohort/cohort";
import { CohortLeaderTableWrapper } from "../../components/CohortInsights/Restrictions";
import { Breadcrumb } from "../../components/Breadcrumb/Breadcrumb";
import { useConfidentialReportView } from "../../hooks/confidentialReportView";
import { useColumnedTableReportData } from "../../common/cohortTableColumns";
var CohortInsightsSkillContent = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var insightSetMap = _a.insightSet, assessmentCategory = _a.assessmentCategory, isConfidential = _a.isConfidential;
    var params = useParams() || {};
    var reportId = params.reportId, skillGroup = params.skillGroup, skillName = params.skillName;
    var report = useGetSingleAvailableCohortReportsQuery({
        reportId: reportId || "",
    });
    var skillGroupInfo = (_b = cohortSet[assessmentCategory || ""]) === null || _b === void 0 ? void 0 : _b[skillGroup];
    if (!insightSetMap[assessmentCategory || ""]) {
        return (_jsx(PageNotFound, { title: "unknown category: ".concat(assessmentCategory), description: "unknown category: ".concat(assessmentCategory) }));
    }
    if (!insightSetMap[assessmentCategory || ""][skillGroup || ""]) {
        return (_jsx(PageNotFound, { title: "unknown skill group: ".concat(skillGroup), description: "unknown skill group: ".concat(skillGroup) }));
    }
    var insightSet = insightSetMap[assessmentCategory || Tab.CBI][skillGroup || ""];
    var useTableData = insightSet.useTableData, useChartData = insightSet.useChartData;
    var allFilters = useContext(FilterContext).getFilters;
    var disableFilters = useConfidentialReportView(isConfidential).disableFilters;
    var column1Attribute = (_d = (_c = report === null || report === void 0 ? void 0 : report.data) === null || _c === void 0 ? void 0 : _c.leaderTableOptions) === null || _d === void 0 ? void 0 : _d.column1Attribute;
    var column2Attribute = (_f = (_e = report === null || report === void 0 ? void 0 : report.data) === null || _e === void 0 ? void 0 : _e.leaderTableOptions) === null || _f === void 0 ? void 0 : _f.column2Attribute;
    var cohortTableSKillData = useColumnedTableReportData({
        useTableData: useTableData,
        skillGroup: skillGroup,
        skill: skillName,
        category: assessmentCategory,
        reportId: reportId,
    });
    var leaderCountData = useGetCohortReportLeaderCount({
        category: assessmentCategory,
        filters: allFilters(),
    }).data;
    return (_jsxs(_Fragment, { children: [_jsx(FilteredOverviewPage, { availableFilters: CohortFilterSet, title: skillName, secondaryHeadingTitle: "".concat((skillGroupInfo === null || skillGroupInfo === void 0 ? void 0 : skillGroupInfo.secondaryTitle) || "", ": ").concat(skillName), leftTrailer: _jsx("div", __assign({ style: { paddingTop: "2px" } }, { children: _jsx(LeaderCount, { leadersCount: ((_g = leaderCountData === null || leaderCountData === void 0 ? void 0 : leaderCountData.data) === null || _g === void 0 ? void 0 : _g.leadersCount) || 0, countText: "leader" }) })), rightTrailer: _jsx(MutateReportButtons, { reportId: reportId }), disableFilters: disableFilters, backToButton: _jsx(Breadcrumb, {}) }), _jsxs("div", __assign({ "data-testid": "CohortInsightsSkill", className: styles.container }, { children: [_jsx(DistributionBarSet, { useChartData: useChartData, reportId: reportId, category: assessmentCategory, skillGroup: skillGroup, skillName: skillName, barTitle: insightSet.skillBarChartTitle(skillName), barChartProps: insightSet.skillBarChartProps, donutTitle: insightSet.skillDonutTitle || "" }), _jsx(CohortLeaderTableWrapper, { children: _jsx("div", __assign({ className: styles.scoringFactorContainer }, { children: _jsx(CohortInsightsSkillsTable, { data: cohortTableSKillData, title: "".concat(assessmentCategory == Tab.SavilleSwiftAptitude
                                    ? insightSet.skillGroupDisplayName
                                    : skillName, " Scores by Leader"), filename: "cohort-insights-table.png", getColumnDescriptions: insightSet.skillDrilldownColumns || (function () { return []; }), column1Attribute: column1Attribute, column2Attribute: column2Attribute }) })) })] }))] }));
};
export var CohortInsightsSkillV2 = function (props) {
    var params = useParams() || {};
    var reportData = useGetSingleAvailableCohortReportsQuery({
        reportId: params.reportId || "",
    }, { shouldSkipCall: function () { return !params.reportId; } });
    var _a = reportData.data || {}, assessmentCategory = _a.assessmentCategory, isConfidential = _a.isConfidential;
    if (reportData.isLoading) {
        return null;
    }
    return (_jsx(CohortInsightsSkillContent, { insightSet: props.insightSet, assessmentCategory: assessmentCategory, isConfidential: isConfidential }, assessmentCategory || "unknown"));
};
